<template>
  <section class="ecppt-presale__section">
    <div class="ecppt-presale__content">
      <div class="ecppt-presale__text">
        <div class="ecppt-presale__text-title-enquiry">PRE-SALE SAVINGS FOR NEW SUBSCRIBERS</div>
        <div class="ecppt-presale__text-title">Buy now and save $200!</div>
        <div class="ecppt-presale__details">
          Pre-Sale available now for <strong>NEW SUBSCRIBERS!</strong> Purchase the eCPPT exam
          voucher during pre-sale and receive three months of INE’s Premium subscription to help you
          prepare! Don’t wait – purchase during pre-sale and <strong>SAVE $200</strong> off regular
          pricing. You’ll be one of the first eligible to take the eCPPT exam when it becomes
          available on June 18, 2024!
          <span @click="modalVisible = true" class="ecppt-presale__details--link"
            >Terms apply.</span
          >
        </div>
        <div class="ecppt-presale__cta">
          <button class="btn btn--primary btn--responsive btn--full-mobile" @click="claimDealCTA">
            Claim this deal
          </button>
        </div>
      </div>
      <img :src="eCPPTBadgeIcon()" alt="eEDA Premium Dynamic Exam" class="ecppt-presale__badge" />
    </div>
    <div v-if="modalVisible" class="ecppt-presale__alert">
      <AlertModal @close-modal="closeModal()">
        <div class="ecppt-presale__alert-wrapper">
          <h1 class="ecppt-presale__alert-title">Terms and Conditions</h1>
          <div class="ecppt-presale__alert-content">
            <ul class="ecppt-presale__alert-content-list">
              <li>
                $200.00 off Certified Professional Penetration Testing Certification plus 3 months
                of Premium subscription is only valid through June 17, 2024 for NEW subscribers
                only.
              </li>
              <li>
                Full prices as of 06/18/2024:
                <ul>
                  <li>eCPPT+3 - $599.00</li>
                  <li>eCPPT Exam Voucher - $399.00</li>
                </ul>
              </li>
              <li>
                eCPPT + three months of training includes three months of Premium subscription.
                Subscriber will be charged after the initial three month offer at the prorated price
                of $350.00 unless canceled prior to renewal.
              </li>
              <li>
                Offer valid on new eCPPT subscribers, we reserve the right to change this offer at
                any time.
              </li>
              <li>
                Once purchased, the eCPPT certification exam voucher will be in your account
                beginning on 06/18/2024 and available to attempt for 180 days. You will have two
                attempts to pass the certification exam.
              </li>
              <li>
                Discounts cannot be applied to previous orders or be combined with any other offer.
                We reserve the right to change or discontinue this offer at any time.
              </li>
              <li>
                If you purchased a certification voucher for the existing eCPPT, please
                visit&nbsp;<a
                  class="ecppt-presale__alert-content-link"
                  href="https://security.ine.com/ecppt-voucher-exchange/"
                  target="_blank"
                  >https://security.ine.com/ecppt-voucher-exchange/</a
                >
                to learn about the voucher exchange program.
              </li>
              <li>
                If you have any questions, please email us at&nbsp;<a
                  class="ecppt-presale__alert-content-link"
                  href="mailto:support@ine.com"
                  target="_blank"
                  >support@ine.com</a
                >
              </li>
            </ul>
          </div>
          <button class="btn btn--primary exam-content__alert__cta" @click="closeModal()">
            Close
          </button>
        </div>
      </AlertModal>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { updateCart } from '@/helpers/mixins'
import eCPPTBadgeIcon from '@/assets/icons/certs/eCPPT-badge.png'
import AlertModal from '@/components/shared/AlertModal.vue'

export default {
  name: 'eCPPTPreSaleSection',
  mixins: [updateCart],
  components: {
    AlertModal,
  },
  data() {
    return {
      modalVisible: false,
    }
  },
  methods: {
    eCPPTBadgeIcon() {
      return eCPPTBadgeIcon
    },
    getECPPT_Plan() {
      return this.availablePlans.find(plan => plan.merchant_id === 'ecppt_premium')
    },
    claimDealCTA() {
      const currentPlan = this.getECPPT_Plan()
      if (this.selectedPlan !== currentPlan) {
        this.updateSelectedPlan(this.getECPPT_Plan())
      }
      this.$router.push({
        name: this.userProfile.email ? 'payment' : 'account',
      })
    },
    closeModal() {
      this.modalVisible = false
    },
  },
  computed: {
    ...mapState({
      availablePlans: state => state.products.availablePlans,
      userProfile: state => state.auth.userProfile,
    }),
  },
}
</script>

<style lang="scss">
.ecppt-presale {
  &__section {
    padding: 30px 20px;
    @include mobile {
      padding: 20px;
    }
    @include desktop {
      padding: 90px 20px;
    }
  }
  &__content {
    display: flex;
    flex-flow: column-reverse;
    align-items: center;
    gap: 40px;
    @include mobile {
      flex-flow: row;
      gap: 40px;
    }
    @include desktop {
      gap: 60px;
      max-width: 1120px;
      margin: auto;
      align-items: center;
    }
  }
  &__badge {
    width: 50%;
    @include mobile {
      width: 363px;
    }
    @include desktop {
      width: 392px;
    }
  }
  &__text {
    font-family: var(--font-medium);
    color: var(--white);
    &-title {
      margin-top: 10px;

      color: var(--white);
      font-feature-settings: 'clig' off, 'liga' off;

      font-family: var(--font-regular);
      font-size: 2rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.375rem; /* 118.75% */

      @include mobile {
        font-size: 2.5rem;
        line-height: 3.25rem;
      }
      @include desktop {
        font-size: 3.375rem;
        line-height: 3.75rem;
      }
      &-enquiry {
        color: var(--light-purple);
        font-feature-settings: 'clig' off, 'liga' off;
        text-shadow: 0px 0px 24px #000;

        font-family: var(--font-regular);
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem; /* 142.857% */

        @include mobile {
          font-size: 1rem;
          line-height: 1.4375rem;
        }
        @include desktop {
          font-size: 0.9375rem;
          font-weight: 700;
          line-height: 0.875rem;
        }
      }
    }
  }
  &__details {
    margin-top: 10px;

    color: var(--white);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: var(--font-regular);
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 450;
    line-height: 1.25rem; /* 142.857% */

    @include desktop {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }
    &--link {
      color: var(--purple-pale);
      font-size: rem(18px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(24px);
      cursor: pointer;
    }
  }
  &__cta {
    margin-top: 10px;
    @include mobile {
      margin-top: 20px;
    }
    @include desktop {
      margin-top: 40px;
    }
    &--hide {
      display: none !important;
    }
  }
  &__alert {
    &-wrapper {
      padding: 30px;
      max-width: 600px;
    }
    &-title {
      color: var(--white);
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 52px;
      margin-top: 40px;
      margin-bottom: 20px;
    }
    &-content {
      text-align: left;
      color: var(--light-blue-gray);
      font-size: rem(10px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(12px);
      margin-bottom: 40px;
      &-list {
        padding: 0;
        list-style-type: disc;
        ul {
          list-style-type: disc;
          padding-left: 20px;
        }
      }
      &-link {
        color: var(--purple-pale);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    &__cta {
      margin-top: 20px;
    }
  }
}
</style>
